import bus from '../utils/basicConfig/bus.js'; //引入bus配置
export const idNumberMixins = {
  methods: {
    // 校验投保人名称
    async blurCompanyNameHandle(name, type) {
      if (!type) {
        return;
      }
      let code = (await this.queryCompanyListByName(name, type)) || '';
      return code;
    },
    /**
     * 当证件类型=营业执照或统一社会信用代码, 第三方获取
     * @param {*} name 公司名
     */
    async queryCompanyListByName(name, type) {
      //查询目标公司开户信息
      let data = {
        keyword: name
      };
      let companyId = '';
      await this.$api.enterpriseSearchByName(data).then(r => {
        if (r.data.content.items) {
          const companyList = r.data.content.items;
          companyList.some(item => {
            if (item.entname === name) {
              companyId = item.id;
              return true;
            }
            return false;
          });
        }
      });
      if (companyId) {
        return await this.queryCompanyCode(companyId, type, name);
      }
      return false;
    },
    // 根据公司id查询公司信息 type 1：统一社会信用代码，2：工商营业执照，3：组织机构代码证，4：税务登记证(第三方证件库)
    async queryCompanyCode(companyId, type, name) {
      let data = {
        id: companyId
      };
      let companyCode = '';
      await this.$api.queryCompanyInfoById(data).then(r => {
        // "ORGCODE": "312375725", //组织机构编码
        // "OPLOC": "上海市崇明区横沙乡富民支路58号3419室（上海横泰经济开发区）", //公司地址
        // "GONGSH": "310105000463337", //工商注册号
        // "code": "200",
        // "TAXNUMBER": "91310230312375725G", //纳税人识别号（2）
        // "UNCID": "91310230312375725G", //纳税人识别号
        // "HASUNIFY": true,
        // "ENTNAME": "上海南燕信息技术有限公司", //公司名称
        // "message": "success"
        if (r.data.returnCode == '00' && r.data.content) {
          let data = r.data.content;
          // 查询出的公司统一信用代码
          const creditCode = data.UNCID || data.TAXNUMBER || '';
          // 如果查询到统一信用代码
          if (creditCode) {
            companyCode = creditCode;
            // 调接口保存第三方查询出的证件号码
            this.thirdPartyAdd(creditCode, name);
          } else {
            // 如果未查询到统一信用代码，则按照选择的证件类型获取对应的证件号码
            if (type == 1) {
              companyCode = data.UNCID || data.TAXNUMBER || '';
            } else if (type == 2 || type == 3) {
              const codeType = {
                2: 'GONGSH',
                3: 'ORGCODE'
              };
              let typeName = codeType[type];
              companyCode = data[typeName] || '';
            } else {
              companyCode = '';
            }
          }
        }
      });
      return companyCode;
    },
    // 根据公司名称和证件类型查询证件号
    async queryCompanyIdNumber(enterpriseName, idType, companyIdTypeOptions, idNumberFn) {
      if (!enterpriseName || !idType) {
        return;
      }
      enterpriseName = enterpriseName.trim();
      let queryIdType = `${idType}`;
      if (companyIdTypeOptions) {
        // 产品中对应的证件类型
        let typeObj = companyIdTypeOptions.find(item => item.value == idType);
        if(!typeObj){return;}
        const needIdTypes = [
          {
            name: '社会信用代码',
            value: '1'
          },
          {
            name: '营业执照',
            value: '2'
          },
          {
            name: '组织机构代码',
            value: '3'
          },
          {
            name: '税务登记',
            value: '4'
          }
        ];
        needIdTypes.some(item => {
          if (typeObj.name.indexOf(item.name) > -1) {
            queryIdType = item.value;
            return true;
          }
          return false;
        });
      }
      // 证件类型，1：统一社会信用代码，2：工商营业执照，3：组织机构代码证，4：税务登记证
      let companyCode = '';
      const formData = new FormData();
      formData.append('enterpriseName', enterpriseName);
      formData.append('idType', queryIdType);
      const params = {
        enterpriseName,
        idType: queryIdType
      };

      // 先中台证件库查询
      await this.$api.queryCertificate(formData).then(r => {
        if (r.data.returnCode == '0000' && r.data.data) {
          companyCode = r.data.data;
        }
      });

      // 如果没有在中台证件库查询到证件号码
      if (!companyCode) {
        // 再从第三方查询
        companyCode = await this.blurCompanyNameHandle(enterpriseName, queryIdType);
      }
      this.sureSetIdNumber(companyCode, idNumberFn);
      if (companyCode === '') {
        this.showAddIdNumber(params);
      }
    },
    // 保存从第三方接口获取到的证件号码
    thirdPartyAdd(idNumber, name) {
      const params = {
        enterpriseName: name,
        idType: '1',
        idNo: idNumber
      };
      this.$api.thirdPartyAdd(params);
    },
    // 打开补充证件号窗口
    showAddIdNumber(params) {
      bus.$emit('showAddIdNumber', true, params);
    },
    // 赋值iDNumber idNumberFn->当前需要赋值idNumber的方法
    sureSetIdNumber(code, idNumberFn) {
      if (idNumberFn) {
        const fn = this[idNumberFn] || idNumberFn
        fn(code);
        return;
      }
      if (this.form) {
        this.form.setFieldsValue({
          applicantInfo: {
            idNumber: code
          }
        });
      }
      this.applicantInfo.idNumber = code;
    },
  }
};
